<template>
    <div class="d-flex">
        <v-btn
            v-if="canValidateFinish"
            color="success"
            @click="validateFinishWorkOrders"
            class="ml-2"
            :disabled="validateFinishLoading || validateCloseLoading"
            :loading="validateFinishLoading"
        >
            <v-icon class="mr-1">mdi-check-circle</v-icon>
            <span class="text-capitalize">VALIDATE FINISH</span>
        </v-btn>
        <v-btn
            v-if="canValidateClose"
            color="warning"
            @click="validateCloseWorkOrders"
            class="ml-2"
            :disabled="validateCloseLoading || validateFinishLoading"
            :loading="validateCloseLoading"
        >
            <v-icon class="mr-1">mdi-lock</v-icon>
            <span class="text-capitalize">VALIDATE CLOSE</span>
        </v-btn>

        <v-dialog
            v-model="validationResultsDialog"
            persistent
            max-width="800px"
        >
            <v-card>
                <v-card-title class="text-h5">
                    {{ validationResultsTitle }}
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row
                            v-if="
                                validationResults.finished &&
                                    validationResults.finished.length > 0
                            "
                        >
                            <v-col cols="12">
                                <h3 class="success--text mb-2">
                                    Finished Work Orders ({{
                                        validationResults.finished.length
                                    }})
                                </h3>
                                <v-chip
                                    v-for="wo in validationResults.finished"
                                    :key="wo.id"
                                    color="success"
                                    class="ma-1"
                                >
                                    {{ wo.code }}
                                </v-chip>
                            </v-col>
                        </v-row>
                        <v-row
                            v-if="
                                validationResults.closed &&
                                    validationResults.closed.length > 0
                            "
                        >
                            <v-col cols="12">
                                <h3 class="warning--text mb-2">
                                    Closed Work Orders ({{
                                        validationResults.closed.length
                                    }})
                                </h3>
                                <v-chip
                                    v-for="wo in validationResults.closed"
                                    :key="wo.id"
                                    color="warning"
                                    class="ma-1"
                                >
                                    {{ wo.code }}
                                </v-chip>
                            </v-col>
                        </v-row>
                        <v-row
                            v-if="
                                !hasValidationResults ||
                                    (validationResults.finished?.length === 0 &&
                                        validationResults.closed?.length === 0)
                            "
                        >
                            <v-col cols="12">
                                <p class="text-center grey--text">
                                    No work orders passed validation
                                </p>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="closeValidationResults">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import API from '@/services/api'
import { mapMutations } from 'vuex'

export default {
    name: 'ValidationWorkOrders',
    props: {
        projectId: {
            type: String,
            default: undefined,
        },
        user: {
            type: Object,
            default: () => ({}),
        },
        projectManager: {
            type: String,
            default: undefined,
        },
    },
    data: () => ({
        validationResultsDialog: false,
        validationResults: {},
        validationResultsTitle: '',
        validateFinishLoading: false,
        validateCloseLoading: false,
    }),
    computed: {
        canValidateFinish() {
            const currentRoute = this.$route.name
            return (
                this.user?.permissions?.includes('finishWO') &&
                currentRoute !== 'finished'
            )
        },
        canValidateClose() {
            const currentRoute = this.$route.name
            return (
                !['main-work-orders', 'wo-progress'].includes(currentRoute) &&
                (this.user?.permissions?.includes('closeWO') ||
                    (this.projectManager &&
                        this.projectManager == this.user?.id))
            )
        },
        hasValidationResults() {
            return (
                (this.validationResults.finished &&
                    this.validationResults.finished.length > 0) ||
                (this.validationResults.closed &&
                    this.validationResults.closed.length > 0) ||
                (this.validationResults.notFinished &&
                    this.validationResults.notFinished.length > 0) ||
                (this.validationResults.errors &&
                    this.validationResults.errors.length > 0)
            )
        },
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        async validateFinishWorkOrders() {
            try {
                this.validateFinishLoading = true
                let params = {}
                if (this.projectId) {
                    params.projectId = this.projectId
                }
                const result = await API.validateFinishWorkOrders(params)
                this.validationResults = result
                this.validationResultsTitle = 'Finalization Validation Results'
                this.validationResultsDialog = true
            } catch (error) {
                console.log('error', error)
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.validateFinishLoading = false
            }
        },
        async validateCloseWorkOrders() {
            try {
                this.validateCloseLoading = true
                let params = {}
                if (this.projectId) {
                    params.projectId = this.projectId
                }
                const result = await API.validateCloseWorkOrders(params)
                this.validationResults = result
                this.validationResultsTitle = 'Closing Validation Results'
                this.validationResultsDialog = true
            } catch (error) {
                console.log('error', error)
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.validateCloseLoading = false
            }
        },
        closeValidationResults() {
            this.validationResultsDialog = false
            this.validationResults = {}
            this.validationResultsTitle = ''
        },
    },
}
</script>
